import { useEffect, useState } from 'react'
import ActiveSubscription from '../../components/subscription/ActiveSubscription'
import SubscriptionPlanList from '../../components/subscription/SubscriptionPlanList'
import PaymentModal from '../../components/subscription/PaymentModal'
import PaymentNotification from '../../components/common/PaymentNotification'
import { useAuth } from '../../contexts/AuthContext'
import { PAYMENT_ID_KEY } from '../../constants/payment'
import BackButtonAndTitle from '../../components/retailer-shop/BackButtonAndTitle'
import SeoHelmet from '../../components/common/SeoHelmet'

const SubscriptionsPage = () => {
  const { currentUser, refresh } = useAuth()
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [showSwitchPlan, setShowSwitchPlan] = useState(false)

  useEffect(() => {
    refresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const handleGetStarted = (plan) => {
    setSelectedPlan(plan)
    setShowPaymentModal(true)
  }

  const handleSwitchPlan = () => {
    setShowSwitchPlan(true)
  }

  const handleBackFromSwitch = () => {
    setShowSwitchPlan(false)
  }

  const onClosePaymentModal = () => {
    setShowPaymentModal(false)
  }

  const hasPendingPayment = () => localStorage.getItem(PAYMENT_ID_KEY)

  const renderContent = () => {
    if (hasPendingPayment()) {
      return (
        <PaymentNotification
          onClose={() => {}}
          onRetryPayment={(plan) => {
            setSelectedPlan(plan)
            setShowPaymentModal(true)
          }}
        />
      )
    }

    if (showSwitchPlan) {
      return (
        <div className="space-y-6">
          <BackButtonAndTitle title="Switch Subscription Plan" onBack={handleBackFromSwitch} />
          <SubscriptionPlanList onGetStarted={handleGetStarted} />
        </div>
      )
    }

    if (currentUser?.activeSubscription?.id) {
      return <ActiveSubscription onSwitchPlan={handleSwitchPlan} />
    }

    return <SubscriptionPlanList onGetStarted={handleGetStarted} />
  }

  return (
    <div className="main-container h-full">
      <SeoHelmet
        title="Subscription Plans"
        description="Choose the perfect subscription plan for your business on Sokooni marketplace. Upgrade your seller account with premium features and benefits."
        keywords="subscription plans, premium features, seller subscription, business plans, marketplace subscription, Sokooni plans"
        url="/subscription"
      />
      {renderContent()}
      <PaymentModal isOpen={showPaymentModal} onClose={onClosePaymentModal} plan={selectedPlan} />
    </div>
  )
}

export default SubscriptionsPage
